<template>
  <router-view />
</template>

<script lang="ts">
import Vue from "vue";
import { syncDocumentLanguage } from "@/helpers/documentLanguage";

export default Vue.extend({
  name: "App",
  data: function () {
    const lang = localStorage.getItem("lang") || "el";
    return { lang: lang };
  },
  mounted() {
    syncDocumentLanguage(this.lang);
  },
  methods: {
    handleChange(event: any) {
      localStorage.setItem("lang", event.target.value);
      syncDocumentLanguage(event.target.value);
      window.location.reload();
    },
  },
});
</script>

<style src="./styles/app.scss" lang="scss" />
